import { Collection } from "src/types/collections";
import type { UnknownAction } from "@reduxjs/toolkit";
import {
  FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST,
  FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED,
  FETCHING_DISCOVERY_POPULAR_ASSETS,
  FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED,
  FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED,
  FETCHING_DISCOVERY_SEARCH_QUERIES,
  FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED,
  FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED,
  FETCHING_DISCOVERY_SEARCH_TAGS,
  FETCHING_DISCOVERY_SEARCH_TAGS_FAILED,
  FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_TOP_SHARERS,
  FETCHING_DISCOVERY_TOP_SHARERS_FAILED,
  FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED,
  FETCHING_DISCOVERY_TOP_USERS,
  FETCHING_DISCOVERY_TOP_USERS_FAILED,
  FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED,
  FETCHING_DISCOVERY_TOP_USER_GROUPS,
  FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED,
  FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_USERS,
  FETCHING_ENGAGEMENT_TOP_USERS_FAILED,
  FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_LEADS_DETAIL_REPORT,
  FETCHING_LEADS_DETAIL_REPORT_FAILED,
  FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED,
  FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED,
  FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED,
  FETCHING_PERFORMANCE_DEALS_FAILED,
  FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_DEALS_SUCCEEDED,
  FETCHING_PERFORMANCE_DEAL_VALUE_FAILED,
  FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT,
  FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED,
  FETCHING_PERFORMANCE_INTERACTIONS_FAILED,
  FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED,
  FETCHING_PERFORMANCE_LEADS_FAILED,
  FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_LEADS_SUCCEEDED,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED,
  INTIALIZING_DOWNLOAD_REPORT_FAILED,
  INTIALIZING_DOWNLOAD_REPORT_REQUEST,
  INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED,
  INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS,
  INVALIDATE_REPORTS_DOWNLOAD_DATA,

  FETCH_ADVOCACY_TIME_SPENT,
  FETCHING_ADVOCACY_TIME_SPENT_SUCCEEDED,

  FETCH_ADVOCACY_VIEWS,
  FETCHING_ADVOCACY_VIEWS_SUCCEEDED,
  FETCHING_ADVOCACY_VIEWS_FAILED,

  FETCH_ADVOCACY_SHARES,
  FETCHING_ADVOCACY_SHARES_SUCCEEDED,
  FETCHING_ADVOCACY_SHARES_FAILED,

  FETCH_ADVOCACY_TOP_SHARERS,
  FETCHING_ADVOCACY_TOP_SHARERS_SUCCEEEDED,
  FETCHING_ADVOCACY_TOP_SHARERS_FAILED,

  FETCH_ADVOCACY_TOP_SHARED_ASSETS,
  FETCHING_ADVOCACY_TOP_SHARED_ASSETS_SUCCEEDED ,
  FETCHING_ADVOCACY_TOP_SHARED_ASSETS_FAILED,
  FETCHING_ADVOCACY_TIME_SPENT_FAILED,
  FETCH_ADVOCACY_TOP_USER_GROUPS,
  FETCHING_ADVOCACY_TOP_USER_GROUPS_SUCCEEDED,
  FETCHING_ADVOCACY_TOP_USER_GROUPS_FAILED,
  FETCH_ADVOCACY_TOP_ENGAGED_ASSETS,
  FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_SUCCEEDED,
  FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_FAILED,
  FETCHING_DISCOVERY_DEAL_ROOMS_REPORT,
  FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_SUCCEEDED,
  FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_FAILED,
  FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT,
  FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_FAILED,
  FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES,
  FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_FAILED
} from "../actions/actionTypes";
import {
  FetchDiscoveryCollectionsErrorResponse,
  FetchDiscoveryCollectionsResponse,
  FetchDiscoveryCollectionsSharedResponse,
  FetchDiscoveryPopularAssetsErrorResponse,
  FetchDiscoveryPopularAssetsResponse,
  FetchDiscoverySearchQueriesErrorResponse,
  FetchDiscoverySearchQueriesResponse,
  FetchDiscoverySearchTagsErrorResponse,
  FetchDiscoverySearchTagsResponse,
  FetchDiscoveryTopSharesErrorResponse,
  FetchDiscoveryTopSharesResponse,
  FetchDiscoveryTopUserGroupsResponse,
  FetchDiscoveryTopUsersErrorResponse,
  FetchDiscoveryTopUsersResponse,
  FetchReportSummaryNudgesResponse,
  FetchDiscoveryDealRoomsErrorResponse,
  FetchDiscoveryDealRoomsSharedResponse,
  FetchDiscoveryDealRoomsResponse,
  FetchEngagementDealRoomReportResponse
} from "src/types/reports";
import { Users } from "src/types/streamAccessControl";
import { Asset } from "src/types/assets";

import _ from "lodash";
import { Conversation } from "src/types/conversations";
import { DealRoom } from "src/types/dealRoom";

interface DiscoveryState {
  popularAssets: PopularAssetsState;
  assetsShared: AssetsSharedState;
  topUsers: TopUsersState;
  topSharers: TopSharersState;
  topUserGroups: TopUserGroupsState;
  collectionsCreated: CollectionsCreatedState;
  collectionsShared: CollectionsSharedState;
  searchQueries: SearchQueriesState;
  searchTags: SearchTagsState;
  assetViewsGraph: AssetViewsGraphState;
  assetsGraph: AssetsGraphState;
  collectionActivityGraph: CollectionActivityGraphState;
  sharesGraph: SharesGraphState;
  contentMatrix: ContentMatrixState;
  contentMatrixAssets: ContentMatrixAssetsState;
  dealRoomsCreated: DealRoomsCreatedState;
  dealRoomsShared: DealRoomsSharedState;
}

interface EngagementState {
  attentionTime: AttentionTimeGraphState;
  uniqueViewers: UniqueViewersGraphState;
  sharesGraph: EngageSharesGraphState;
  assetViewsGraph: EngageAssetViewsGraphState;
  popularAssets: EngagePopularAssetsState;
  topUsers: EngageTopUsersState;
  topAccounts: EngageTopAccountsState;
  campaigns: EngageCampaignState;
  campaignSources: EngageCampaignSourceState;
  conversationActivities: ConversationActivitiesState;
  collectionActivities: CollectionActivitiesState;
  dealRoomActivities: DealRoomActivitiesState;
}

interface PerformanceState {
  interactions: InteractionState;
  leads: LeadsState;
  deals: DealState;
  dealValue: DealValueState;
  closedDeals: ClosedDealsState;
  closedDealValue: ClosedDealValue;
  topLeadsContent: TopLeadsContentState;
  contentClosedDeals: ContentClosedDealsState;
  leadsDetail: LeadsDetailsState;
  dealsDetail: DealsDetailsState;
}

interface AdvocacyState {
  sharesGraph: CollectionActivityGraphState;
  viewsGraph: AssetsGraphState;
  timeSpentGraph: AssetViewsGraphState;
  assetsShared: AssetsSharedState;
  assetsEngaged: AssetsEngagedState;
  topSharers: TopSharersState;
  topUserGroups: TopUserGroupsState;
}

interface AssetsSummary {
  assets: number;
}

interface ActiveUserSummary {
  activeUsers: number;
}

interface SessionSummary {
  teamViews: number;
}

interface ShareSummary {
  shares: number;
}

interface ContactSummary {
  engagedContacts: number;
}

interface LeadSummary {
  leads: number;
}

interface DealSummary {
  deals: number;
  dealValue: number;
}

interface ReportSummaryItem {
  assets: AssetsSummary;
  activeUser: ActiveUserSummary;
  session: SessionSummary;
  share: ShareSummary;
  contact: ContactSummary;
  lead: LeadSummary;
  deal: DealSummary;
}
interface ReportsState {
  discovery: DiscoveryState;
  engagement: EngagementState;
  performance: PerformanceState;
  advocacy: AdvocacyState;
  reportSummary: ReportsSummaryState;
  download: DownloadState;
}

interface ReportsSummaryState {
  loading: boolean;
  error: any;
  item: ReportSummaryItem | null;
}

interface AssetsSharedState {
  loading: boolean;
  items: PopularAssetsItem[];
  pagination: PaginationState;
}

interface AssetsEngagedState {
  loading: boolean;
  items: PopularAssetsItem[];
  pagination: PaginationState;
}

interface UserGroup {
  id: string;
  name: string;
  description: string | null;
  admin: boolean;
  createStream: boolean;
  users: null;
  createdBy: string | null;
  createdDate: number;
  modifiedDate: number | null;
  usersCount: number;
  icons: string | null;
}

interface Analytics {
  total: number;
  views: number;
  avgTimeSpent: number;
  shares: number;
  assets: number;
  users: number;
  collections: number;
  recipients: number;
  downloads: number;
}

interface TopUserGroupItem {
  userGroup: UserGroup;
  analytics: Analytics;
}

interface PopularAssetsItem {
  assets: Asset[];
  analytics: Analytics;
}

interface TopUsersItem {
  users: Users;
  analytics: Analytics;
}

interface CollectionsCreatedItem {
  collection: Collection;
  analytics: Analytics;
}

interface DealRoomsCreatedItem {
  dealRoom: DealRoom;
  analytics: Analytics;
}
interface SearchQueriesItem {
  query: string;
  totalCount: number;
}

interface SearchTagsItem {
  key: string;
  searchCount: number;
  assersCount: number;
}
interface TopUserGroupsState {
  loading: boolean;
  items: TopUserGroupItem[];
  pagination: PaginationState;
}

interface CollectionsCreatedState {
  loading: boolean;
  items: CollectionsCreatedItem[];
  pagination: PaginationState;
}

interface CollectionsSharedState {
  loading: boolean;
  items: CollectionsCreatedItem[];
  pagination: PaginationState;
}

interface DealRoomsCreatedState {
  loading: boolean;
  items: DealRoomsCreatedItem[];
  pagination: PaginationState;
}

interface DealRoomsSharedState {
  loading: boolean;
  items: DealRoomsCreatedItem[];
  pagination: PaginationState;
}

interface SearchQueriesState {
  loading: boolean;
  items: SearchQueriesItem[];
  pagination: PaginationState;
}

interface SearchTagsState {
  loading: boolean;
  items: SearchTagsItem[];
  pagination: PaginationState;
}

interface TopUsersState {
  loading: boolean;
  items: TopUsersItem[];
  pagination: PaginationState;
}

interface TopSharersState {
  loading: boolean;
  items: TopUsersItem[];
  pagination: PaginationState;
}

interface PopularAssetsState {
  loading: boolean;
  items: PopularAssetsItem[];
  pagination: PaginationState;
}

interface AssetViewsGraphItem {
  key: string;
  value: number;
  cumulative: number;
}

interface AssetViewsGraphState {
  loading: boolean;
  items: AssetViewsGraphItem[];
  error: any;
}

interface AssetsGraphState {
  loading: boolean;
  items: AssetViewsGraphItem[];
  error: any;
}

interface CollectionActivityGraphState {
  loading: boolean;
  items: AssetViewsGraphItem[];
  error: any;
}

interface SharesGraphState {
  loading: boolean;
  items: AssetViewsGraphItem[];
  error: any;
}

interface ContentMatrixAssetsState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface ContentMatrixState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface AttentionTimeGraphState {
  loading: boolean;
  items: any[];
  error: any;
}

interface UniqueViewersGraphState {
  loading: boolean;
  items: any[];
  error: any;
}

interface SharesGraphState {
  loading: boolean;
  items: AssetViewsGraphItem[];
  error: any;
}

interface EngageSharesGraphState {
  loading: boolean;
  items: AssetViewsGraphItem[];
  error: any;
}

interface EngageAssetViewsGraphState {
  loading: boolean;
  items: AssetViewsGraphItem[];
  error: any;
}

interface EngagePopularAssetsState {
  loading: boolean;
  items: PopularAssetsItem[];
  pagination: PaginationState;
}

interface EngageTopUsersState {
  loading: boolean;
  items: TopUsersItem[];
  pagination: PaginationState;
}

interface EngageTopAccountsState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface EngageCampaignState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface EngageCampaignSourceState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface ConversationActivitiesState {
  loading: boolean;
  items: Conversation[];
  pagination: PaginationState;
}

interface CollectionActivitiesState {
  loading: boolean;
  items: Collection[];
  pagination: PaginationState;
}
interface DealRoomActivitiesState {
  loading: boolean;
  items: DealRoom[];
  pagination: PaginationState;
}
interface InteractionState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface LeadsState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface DealState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface DealValueState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface ClosedDealsState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface ClosedDealValue {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface TopLeadsContentState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface ContentClosedDealsState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface LeadsDetailsState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface DealsDetailsState {
  loading: boolean;
  items: any[];
  pagination: PaginationState;
}

interface DownloadState {
  downloading: boolean;
  downloaded: boolean;
  items: any[];
  pagination: PaginationState;
  error: any;
  loading: boolean;
  succeeded: boolean;
}

interface PaginationState {
  currentPage: number;
  totalPages: number;
  recordsPerPage: number;
  totalRecordsCount: number;
}

const initialPaginationState = {
  currentPage: 0,
  totalPages: 0,
  recordsPerPage: 1,
  totalRecordsCount: 0,
};

const downloadPaginationState = {
  currentPage: 0,
  totalPages: 0,
  recordsPerPage: 50,
  totalRecordsCount: 0,
  hasMoreItems: false,
};

const initialDiscoveryState = {
  popularAssets: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  assetsShared: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  topUsers: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  topSharers: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  topUserGroups: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  collectionsCreated: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  collectionsShared: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  searchQueries: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  searchTags: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  assetViewsGraph: {
    loading: false,
    error: null,
    items: [],
  },
  assetsGraph: {
    loading: false,
    error: null,
    items: [],
  },
  collectionActivityGraph: {
    loading: false,
    error: null,
    items: [],
  },
  sharesGraph: {
    loading: false,
    error: null,
    items: [],
  },
  contentMatrixAssets: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  contentMatrix: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  dealRoomsCreated: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  dealRoomsShared: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
};

const initialEngagementState = {
  attentionTime: {
    loading: false,
    items: [],
    error: null,
  },
  uniqueViewers: {
    loading: false,
    items: [],
    error: null,
  },
  sharesGraph: {
    loading: false,
    items: [],
    error: null,
  },
  assetViewsGraph: {
    loading: false,
    items: [],
    error: null,
  },
  popularAssets: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  topUsers: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  topAccounts: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  campaigns: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  campaignSources: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  conversationActivities: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  collectionActivities: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  dealRoomActivities: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
};

const initialPerformanceState = {
  interactions: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  leads: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  deals: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  dealValue: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  closedDeals: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  closedDealValue: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  topLeadsContent: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  contentClosedDeals: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  leadsDetail: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  dealsDetail: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
};

const initialAdvocacyState = {
  sharesGraph: {
    loading: false,
    error: null,
    items: [],
  },
  viewsGraph: {
    loading: false,
    error: null,
    items: [],
  },
   timeSpentGraph: {
    loading: false,
    error: null,
    items: [],
  },
  assetsShared: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  assetsEngaged: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  topSharers: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
  topUserGroups: {
    loading: false,
    items: [],
    pagination: { ...initialPaginationState },
  },
};

const initialReportState: ReportsState = {
  discovery: initialDiscoveryState,
  engagement: initialEngagementState,
  performance: initialPerformanceState,
  advocacy: initialAdvocacyState,
  reportSummary: {
    loading: false,
    error: null,
    item: null,
  },
  download: {
    downloading: false,
    downloaded: false,
    items: [],
    pagination: { ...downloadPaginationState },
    error: null,
    loading: false,
    succeeded: false,
  },
};

export function reportsReducer(
  state = initialReportState,
  action: UnknownAction,
) {
  switch (action.type) {
    case FETCHING_DISCOVERY_POPULAR_ASSETS: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          popularAssets: {
            ...state.discovery.popularAssets,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED: {
      const records = action.payload as FetchDiscoveryPopularAssetsResponse;
      let items: PopularAssetsItem[] = [];

      if (records.currentPage != 0) {
        items = [...state.discovery.popularAssets.items, ...records.records];
      } else {
        items = records.records;
      }

      items = _.uniqBy(items, "asset.id");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          popularAssets: {
            ...state.discovery.popularAssets,
            loading: false,
            items: items,
            pagination: {
              currentPage: records.currentPage,
              totalPages: records.totalPages,
              recordsPerPage: records.recordsPerPage,
              totalRecordsCount: records.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED: {
      const error = action.payload as FetchDiscoveryPopularAssetsErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          popularAssets: {
            ...state.discovery.popularAssets,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST: {
      return {
        ...state,
        reportSummary: {
          loading: true,
          error: null,
        },
      };
    }

    case FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED: {
      const { response, nudgesType } =
        action.payload as FetchReportSummaryNudgesResponse;
      return {
        ...state,
        reportSummary: {
          loading: true,
          item: {
            ...state.reportSummary.item,
            [nudgesType]: response,
          },
          error: null,
        },
      };
    }

    case FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED: {
      return {
        ...state,
        reportSummary: {
          ...state.reportSummary,
          loading: true,
          error: action.payload,
        },
      };
    }

    case FETCHING_DISCOVERY_ASSETS_SHARED_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetsShared: {
            ...state.discovery.assetsShared,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED: {
      const payload = action.payload as FetchDiscoveryPopularAssetsResponse;
      const records = payload.records;
      let items: PopularAssetsItem[] = [];

      if (records == null) {
        return;
      }

      if (payload.currentPage != 0) {
        items = [...state.discovery.assetsShared.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "asset.id");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetsShared: {
            ...state.discovery.assetsShared,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED: {
      const error = action.payload as FetchDiscoveryPopularAssetsErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetsShared: {
            ...state.discovery.assetsShared,
            loading: false,
            error: error,
          },
        },
      };
    }
    case FETCHING_DISCOVERY_TOP_USERS: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          topUsers: {
            ...state.discovery.topUsers,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED: {
      const payload = action.payload as FetchDiscoveryTopUsersResponse;
      let items: TopUsersItem[] = [];

      if (payload.currentPage != 0) {
        items = [...state.discovery.topUsers.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "user.id");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          topUsers: {
            ...state.discovery.topUsers,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_TOP_USERS_FAILED: {
      const error = action.payload as FetchDiscoveryTopUsersErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          topUsers: {
            ...state.discovery.topUsers,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_TOP_SHARERS: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          topSharers: {
            ...state.discovery.topSharers,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED: {
      const payload = action.payload as FetchDiscoveryTopSharesResponse;
      let items: TopUsersItem[] = [];

      if (payload.currentPage != 0) {
        items = [...state.discovery.topSharers.items, ...payload.records];
      } else {
        items = payload.records;
      }

      return {
        ...state,
        discovery: {
          ...state.discovery,
          topSharers: {
            ...state.discovery.topSharers,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_TOP_SHARERS_FAILED: {
      const error = action.payload as FetchDiscoveryTopSharesErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          topSharers: {
            ...state.discovery.topSharers,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_TOP_USER_GROUPS: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          topUserGroups: {
            ...state.discovery.topUserGroups,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED: {
      const payload = action.payload as FetchDiscoveryTopUserGroupsResponse;
      let items: TopUserGroupItem[] = [];

      if (payload.currentPage != 0) {
        items = [...state.discovery.topUserGroups.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "userGroup.id");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          topUserGroups: {
            ...state.discovery.topUserGroups,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED: {
      const error = action.payload as FetchDiscoveryTopUsersErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          topUserGroups: {
            ...state.discovery.topUserGroups,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTIONS_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsCreated: {
            ...state.discovery.collectionsCreated,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED: {
      const payload = action.payload as FetchDiscoveryCollectionsResponse;
      let items: CollectionsCreatedItem[] = [];

      if (payload.currentPage != 0) {
        items = [
          ...state.discovery.collectionsCreated.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "collection.id");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsCreated: {
            ...state.discovery.collectionsCreated,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED: {
      const error = action.payload as FetchDiscoveryCollectionsErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsCreated: {
            ...state.discovery.collectionsCreated,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsShared: {
            ...state.discovery.collectionsShared,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED: {
      const payload = action.payload as FetchDiscoveryCollectionsSharedResponse;
      let items: CollectionsCreatedItem[] = [];

      if (payload.currentPage != 0) {
        items = [
          ...state.discovery.collectionsShared.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "collection.id");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsShared: {
            ...state.discovery.collectionsShared,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED: {
      const error = action.payload as FetchDiscoveryCollectionsErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsShared: {
            ...state.discovery.collectionsShared,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SEARCH_QUERIES: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          searchQueries: {
            ...state.discovery.searchQueries,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED: {
      const payload = action.payload as FetchDiscoverySearchQueriesResponse;
      let items: SearchQueriesItem[] = [];

      if (payload.currentPage != 0) {
        items = [...state.discovery.searchQueries.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "query");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          searchQueries: {
            ...state.discovery.searchQueries,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED: {
      const error = action.payload as FetchDiscoverySearchQueriesErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          searchQueries: {
            ...state.discovery.searchQueries,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SEARCH_TAGS: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          searchTags: {
            ...state.discovery.searchTags,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED: {
      const payload = action.payload as FetchDiscoverySearchTagsResponse;
      let items: SearchTagsItem[] = [];

      if (payload.currentPage != 0) {
        items = [...state.discovery.searchTags.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "key");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          searchTags: {
            ...state.discovery.searchTags,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SEARCH_TAGS_FAILED: {
      const error = action.payload as FetchDiscoverySearchTagsErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          searchTags: {
            ...state.discovery.searchTags,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetViewsGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetViewsGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetViewsGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_DISCOVERY_ASSET_GRAPH_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetsGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetsGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          assetsGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionActivityGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionActivityGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          collectionActivityGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SHARE_GRAPH_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          sharesGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          sharesGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          sharesGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrixAssets: {
            ...state.discovery.contentMatrixAssets,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED: {
      const payload = action.payload as any;
      let items: any[] = [];

      if (payload.currentPage != 0) {
        items = [
          ...state.discovery.contentMatrixAssets.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      return {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrixAssets: {
            ...state.discovery.contentMatrixAssets,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrixAssets: {
            ...state.discovery.contentMatrixAssets,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrixAssets: {
            ...state.discovery.contentMatrixAssets,
            loading: false,
            invalidated: true,
            items: [],
            pagination: {
              currentPage: 0,
              totalPages: 0,
              recordsPerPage: 0,
              totalRecordsCount: 0,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrix: {
            loading: true,
            error: null,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrix: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrix: {
            loading: false,
            error: action.payload,
            item: null,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          attentionTime: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          attentionTime: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          attentionTime: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          uniqueViewers: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          uniqueViewers: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          uniqueViewers: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          sharesGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          sharesGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }
    case FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          sharesGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          assetViewsGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          assetViewsGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }
    case FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          assetViewsGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_POPULAR_ASSETS: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          popularAssets: {
            ...state.engagement.popularAssets,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED: {
      const payload = action.payload as any;

      let items: any[] = [];

      if (payload.currentPage != 0) {
        items = [...state.engagement.popularAssets.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "asset.id");

      return {
        ...state,
        engagement: {
          ...state.engagement,
          popularAssets: {
            ...state.engagement.popularAssets,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED: {
      const error = action.paylaod as any;
      return {
        ...state,
        engagement: {
          ...state.engagement,
          popularAssets: {
            ...state.engagement.popularAssets,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_USERS: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          topUsers: {
            ...state.engagement.topUsers,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED: {
      const payload = action.payload as any;

      let items = [] as TopUsersItem[];

      if (payload.currentPage != 0) {
        items = [...state.engagement.topUsers.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "contact.id");

      return {
        ...state,
        engagement: {
          ...state.engagement,
          topUsers: {
            ...state.engagement.topUsers,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_USERS_FAILED: {
      const error = action.paylaod as any;
      return {
        ...state,
        engagement: {
          ...state.engagement,
          topUsers: {
            ...state.engagement.topUsers,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_ACCOUNTS: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          topAccounts: {
            ...state.engagement.topAccounts,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED: {
      const payload = action.payload as any;

      let items: any[] = [];

      if (payload.currentPage != 0) {
        items = [...state.engagement.topAccounts.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "company");

      return {
        ...state,
        engagement: {
          ...state.engagement,
          topAccounts: {
            ...state.engagement.topAccounts,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        engagement: {
          ...state.engagement,
          topAccounts: {
            ...state.engagement.topAccounts,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGNS: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          campaigns: {
            ...state.engagement.campaigns,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED: {
      const payload = action.payload as any;

      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [...state.engagement.campaigns.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "name");

      return {
        ...state,
        engagement: {
          ...state.engagement,
          campaigns: {
            ...state.engagement.campaigns,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        engagement: {
          ...state.engagement,
          campaigns: {
            ...state.engagement.campaigns,
            loading: false,
            error: error,
          },
        },
      };
    }
    case FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          campaignSources: {
            ...state.engagement.campaignSources,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED: {
      const payload = action.payload as any;
      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [...state.engagement.campaignSources.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "name");

      return {
        ...state,
        engagement: {
          ...state.engagement,
          campaignSources: {
            ...state.engagement.campaignSources,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED: {
      const error = action.payload as any;

      return {
        ...state,
        engagement: {
          ...state.engagement,
          campaignSources: {
            ...state.engagement.campaignSources,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          collectionActivities: {
            ...state.engagement.collectionActivities,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED: {
      const payload = action.payload as any;
      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [
          ...state.engagement.collectionActivities.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "collection.id");

      return {
        ...state,
        engagement: {
          ...state.engagement,
          collectionActivities: {
            ...state.engagement.collectionActivities,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        engagement: {
          ...state.engagement,
          collectionActivities: {
            ...state.engagement.collectionActivities,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          conversationActivities: {
            ...state.engagement.conversationActivities,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED: {
      const payload = action.payload as any;
      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [
          ...state.engagement.conversationActivities.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "share.id");

      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          conversationActivities: {
            ...state.engagement.conversationActivities,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      });
    }

    case FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        engagement: {
          ...state.engagement,
          conversationActivities: {
            ...state.engagement.conversationActivities,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          interactions: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          interactions: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_INTERACTIONS_FAILED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          interactions: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          leads: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_LEADS_SUCCEEDED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          leads: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_LEADS_FAILED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          leads: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          deals: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_DEALS_SUCCEEDED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          deals: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_DEALS_FAILED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          deals: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          dealValue: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          dealValue: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_DEAL_VALUE_FAILED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          dealValue: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          closedDeals: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          closedDeals: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          closedDeals: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          closedDealValue: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          closedDealValue: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED: {
      return {
        ...state,
        performance: {
          ...state.performance,
          closedDealValue: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_TOP_LEADS_CONTENT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          topLeadsContent: {
            ...state.performance.topLeadsContent,
            loading: true,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED: {
      const payload = action.payload as any;
      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [
          ...state.performance.topLeadsContent.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "id");

      return {
        ...state,
        performance: {
          ...state.performance,
          topLeadsContent: {
            ...state.performance.topLeadsContent,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        performance: {
          ...state.performance,
          topLeadsContent: {
            ...state.performance.topLeadsContent,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS: {
      return {
        ...state,
        performance: {
          ...state.performance,
          contentClosedDeals: {
            ...state.performance.contentClosedDeals,
            loading: true,
            invalidated: true,
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED: {
      const payload = action.payload as any;
      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [
          ...state.performance.contentClosedDeals.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "id");

      return {
        ...state,
        performance: {
          ...state.performance,
          contentClosedDeals: {
            ...state.performance.contentClosedDeals,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        performance: {
          ...state.performance,
          contentClosedDeals: {
            ...state.performance.contentClosedDeals,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DEALS_REQUEST_DETAIL_REPORT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          dealsDetail: {
            ...state.performance.dealsDetail,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED: {
      const payload = action.payload as any;
      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [...state.performance.dealsDetail.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "id");

      return {
        ...state,
        performance: {
          ...state.performance,
          dealsDetail: {
            ...state.performance.dealsDetail,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED: {
      const error = action.paylaod as any;
      return {
        ...state,
        performance: {
          ...state.performance,
          dealsDetail: {
            ...state.performance.dealsDetail,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_LEADS_DETAIL_REPORT: {
      return {
        ...state,
        performance: {
          ...state.performance,
          leadsDetail: {
            ...state.performance.leadsDetail,
            loading: true,
            invalidated: true,
          },
        },
      };
    }

    case FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED: {
      const payload = action.payload as any;
      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [...state.performance.leadsDetail.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "id");

      return {
        ...state,
        performance: {
          ...state.performance,
          leadsDetail: {
            ...state.performance.leadsDetail,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_LEADS_DETAIL_REPORT_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        performance: {
          ...state.performance,
          leadsDetail: {
            ...state.performance.leadsDetail,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    case INTIALIZING_DOWNLOAD_REPORT_REQUEST: {
      const { page } = action.payload as any;

      let items = state.download.items;

      if (page === 0) {
        items = [];
      }

      return {
        ...state,
        download: {
          downloading: true,
          downloaded: false,
          items: items,
          loading: true,
          succeeded: false,
          error: null,
        },
      };
    }

    case INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED: {
      const result = action.payload as any;

      let items;
      if (result.currentPage === 0) {
        items = result.records;
      } else {
        const existing = state.download.items.slice(0, result.currentPage * result.recordsPerPage);
        items = [...existing, ...result.records];
      }

      const downloading = result.currentPage + 1 < result.totalPages;

      return {
        ...state,
        download: {
          downloading: downloading,
          downloaded: !downloading,
          items: items,
          pagination: {
            currentPage: result.currentPage,
            totalPages: result.totalPages,
            recordsPerPage: result.recordsPerPage,
            totalRecordsCount: result.totalRecordsCount,
            hasMoreItems: downloading,
          },
          error: null,
          loading: false,
          succeeded: true,
        },
      };
    }

    case INTIALIZING_DOWNLOAD_REPORT_FAILED: {
      return {
        ...state,
        download: {
          downloading: false,
          downloaded: false,
          items: [],
          pagination: {
            ...downloadPaginationState,
          },
          error: action.payload,
          loading: false,
          succeeded: false,
        },
      };
    }

    case INVALIDATE_REPORTS_DOWNLOAD_DATA: {
      return {
        ...state,
        download: {
          downloading: false,
          downloaded: false,
          items: [],
          pagination: {
            currentPage: 0,
            totalPages: 1,
            recordsPerPage: 50,
            totalRecordsCount: 0,
            hasMoreItems: false,
          },
          error: null,
          loading: false,
          succeeded: false,
        },
      };
    }

    case FETCH_ADVOCACY_SHARES: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          sharesGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_ADVOCACY_SHARES_SUCCEEDED: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          sharesGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_ADVOCACY_SHARES_FAILED: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          sharesGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCH_ADVOCACY_TIME_SPENT: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          timeSpentGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TIME_SPENT_SUCCEEDED: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          timeSpentGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TIME_SPENT_FAILED: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          timeSpentGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCH_ADVOCACY_VIEWS: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          viewsGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      };
    }

    case FETCHING_ADVOCACY_VIEWS_SUCCEEDED: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          viewsGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      };
    }

    case FETCHING_ADVOCACY_VIEWS_FAILED: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          viewsGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      };
    }

    case FETCH_ADVOCACY_TOP_SHARED_ASSETS: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          assetsShared: {
            ...state.advocacy.assetsShared,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TOP_SHARED_ASSETS_SUCCEEDED: {
      const payload = action.payload as FetchDiscoveryPopularAssetsResponse;
      const records = payload.records;
      let items: PopularAssetsItem[] = [];

      if (records == null) {
        return;
      }

      if (payload.currentPage != 0) {
        items = [...state.advocacy.assetsShared.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "asset.id");

      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          assetsShared: {
            ...state.advocacy.assetsShared,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TOP_SHARED_ASSETS_FAILED: {
      const error = action.payload as FetchDiscoveryPopularAssetsErrorResponse;
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          assetsShared: {
            ...state.advocacy.assetsShared,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCH_ADVOCACY_TOP_ENGAGED_ASSETS: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          assetsEngaged: {
            ...state.advocacy.assetsEngaged,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_SUCCEEDED: {
      const payload = action.payload as FetchDiscoveryPopularAssetsResponse;
      const records = payload.records;
      let items: PopularAssetsItem[] = [];

      if (records == null) {
        return;
      }

      if (payload.currentPage != 0) {
        items = [...state.advocacy.assetsEngaged.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "asset.id");

      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          assetsEngaged: {
            ...state.advocacy.assetsEngaged,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_FAILED: {
      const error = action.payload as FetchDiscoveryPopularAssetsErrorResponse;
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          assetsEngaged: {
            ...state.advocacy.assetsEngaged,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCH_ADVOCACY_TOP_SHARERS: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          topSharers: {
            ...state.advocacy.topSharers,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TOP_SHARERS_SUCCEEEDED: {
      const payload = action.payload as FetchDiscoveryTopSharesResponse;
      let items: TopUsersItem[] = [];

      if (payload.currentPage != 0) {
        items = [...state.advocacy.topSharers.items, ...payload.records];
      } else {
        items = payload.records;
      }

      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          topSharers: {
            ...state.advocacy.topSharers,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TOP_SHARERS_FAILED: {
      const error = action.payload as FetchDiscoveryTopSharesErrorResponse;
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          topSharers: {
            ...state.advocacy.topSharers,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCH_ADVOCACY_TOP_USER_GROUPS: {
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          topUserGroups: {
            ...state.advocacy.topUserGroups,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TOP_USER_GROUPS_SUCCEEDED: {
      const payload = action.payload as FetchDiscoveryTopUserGroupsResponse;
      let items: TopUserGroupItem[] = [];

      if (payload.currentPage != 0) {
        items = [...state.discovery.topUserGroups.items, ...payload.records];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "userGroup.id");

      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          topUserGroups: {
            ...state.advocacy.topUserGroups,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ADVOCACY_TOP_USER_GROUPS_FAILED: {
      const error = action.payload as FetchDiscoveryTopUsersErrorResponse;
      return {
        ...state,
        advocacy: {
          ...state.advocacy,
          topUserGroups: {
            ...state.advocacy.topUserGroups,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_DEAL_ROOMS_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          dealRoomsCreated: {
            ...state.discovery.dealRoomsCreated,
            loading: true,
          },
        },
      };
    }
    
    case FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_SUCCEEDED: {
      const payload = action.payload as FetchDiscoveryDealRoomsResponse;
      let items: DealRoomsCreatedItem[] = [];

      if (payload.currentPage != 0) {
        items = [
          ...state.discovery.dealRoomsCreated.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "dealRoom.dealRoomId");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          dealRoomsCreated: {
            ...state.discovery.dealRoomsCreated,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_FAILED: {
      const error = action.payload as FetchDiscoveryDealRoomsErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          dealRoomsCreated: {
            ...state.discovery.dealRoomsCreated,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT: {
      return {
        ...state,
        discovery: {
          ...state.discovery,
          dealRoomsShared: {
            ...state.discovery.dealRoomsShared,
            loading: true,
          },
        },
      };
    }

    case FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_SUCCEDDED: {
      const payload = action.payload as FetchDiscoveryDealRoomsSharedResponse;
      let items: DealRoomsCreatedItem[] = [];

      if (payload.currentPage != 0) {
        items = [
          ...state.discovery.dealRoomsShared.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "dealRoom.dealRoomId");

      return {
        ...state,
        discovery: {
          ...state.discovery,
          dealRoomsShared: {
            ...state.discovery.dealRoomsShared,
            loading: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_FAILED: {
      const error = action.payload as FetchDiscoveryDealRoomsErrorResponse;
      return {
        ...state,
        discovery: {
          ...state.discovery,
          dealRoomsShared: {
            ...state.discovery.dealRoomsShared,
            loading: false,
            error: error,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES: {
      return {
        ...state,
        engagement: {
          ...state.engagement,
          dealRoomActivities: {
            ...state.engagement.dealRoomActivities,
            loading: true,
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_SUCCEDDED: {
      const payload = action.payload as FetchEngagementDealRoomReportResponse;
      let items = [] as any;

      if (payload.currentPage != 0) {
        items = [
          ...state.engagement.dealRoomActivities.items,
          ...payload.records,
        ];
      } else {
        items = payload.records;
      }

      items = _.uniqBy(items, "dealRoom.dealRoomId");

      return {
        ...state,
        engagement: {
          ...state.engagement,
          dealRoomActivities: {
            ...state.engagement.dealRoomActivities,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: payload.currentPage,
              totalPages: payload.totalPages,
              recordsPerPage: payload.recordsPerPage,
              totalRecordsCount: payload.totalRecordsCount,
            },
          },
        },
      };
    }

    case FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_FAILED: {
      const error = action.payload as any;
      return {
        ...state,
        engagement: {
          ...state.engagement,
          dealRoomActivities: {
            ...state.engagement.dealRoomActivities,
            loading: false,
            invalidated: false,
            error: error,
          },
        },
      };
    }

    default:
      return state;
  }
}
